export default "__VITE_ASSET__61f7810c__"